import { useState } from 'react'
import { Dayjs } from 'dayjs'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Modal } from 'almanac-ui/Modal'
import { RadioGroup, Radio } from 'components/RadioGroup'
import Styles from './AutopilotPauseOption.module.scss'

type AutopilotOption = 'keep_until_end' | 'turn_off_now'

interface Props {
  onBack: () => void
  onCancelSubscription: (turnOffAutopilot: boolean) => void
  onClose: () => void
  subscriptionEndDate: Dayjs
  isLoading: boolean
}

export const AutopilotPauseOption = ({
  onBack,
  onCancelSubscription,
  onClose,
  subscriptionEndDate,
  isLoading,
}: Props) => {
  const [selectedOption, setSelectedOption] = useState<AutopilotOption>('keep_until_end')

  const handleCancelSubscription = () => {
    onCancelSubscription(selectedOption === 'turn_off_now')
  }

  return (
    <div className={Styles.container}>
      <Modal.Header title="Cancel subscription" onClose={onClose} />
      <div className={Styles.content}>
        <div className={Styles.headingWrapper}>
          <Heading level={2}>
            Do you want to keep autopilot running?
          </Heading>
        </div>
        <RadioGroup
          className={Styles.optionsGroup}
          value={selectedOption}
          onChange={(value) => setSelectedOption(value as AutopilotOption)}
          name="autopilot_pause_option"
          aria-label="Autopilot pause option"
        >
          <Radio
            value="keep_until_end"
            className={Styles.optionCard}
            classNames={{
              selected: Styles.optionCardSelected,
            }}
          >
            <div className={Styles.optionContent}>
              <Text variant="primary" color="var(--dark-80)" fontWeight="medium">
                Keep autopilot on until your subscription ends
              </Text>
              <Text variant="secondary" color="var(--dark-60)">
                Autopilot will generate and publish content until {subscriptionEndDate.format('MMM D, YYYY')}.
              </Text>
            </div>
          </Radio>
          <Radio
            value="turn_off_now"
            className={Styles.optionCard}
            classNames={{
              selected: Styles.optionCardSelected,
            }}
          >
            <div className={Styles.optionContent}>
              <Text variant="primary" color="var(--dark-80)" fontWeight="medium">
                Turn off autopilot now
              </Text>
              <Text variant="secondary" color="var(--dark-60)">
                Autopilot will stop immediately.
              </Text>
            </div>
          </Radio>
        </RadioGroup>
      </div>
      <div className={Styles.footer}>
        <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack} isDisabled={isLoading}>
          Back
        </Button>
        <Button variant="primary" size="lg" onPress={handleCancelSubscription} isDisabled={isLoading}>
          Cancel Subscription
        </Button>
      </div>
    </div>
  )
}
